import AddControl_Row from '../AddControlRow';
import CheckBoxControlObject from './CheckBoxControlObject'
import React from 'react';

interface IProps {
    name: string,
    label: string,
    value: boolean,
    isRequired: boolean,
    isReadonly: boolean,
    onChange?: (event: any) => void
    isValid?: boolean
    validationMessage?: string
}

function CheckBoxControlRow(props: IProps) {
    return (
        <AddControl_Row
            component={<CheckBoxControlObject {...props}
        validationMessage={'Value for "' + props.label + '" is required'} />
        }
            description={props.label}
            isReadOnly={props.isReadonly}
            isRequired={props.isRequired} />
    )
}

export default CheckBoxControlRow;